import { graphql } from 'gql';

export const updateProjectGql = graphql(`
    mutation updateProject(
        $uniqueId: String!
        $name: String!
        $stage: ProjectStageEnum!
        $status: ProjectStatusEnum!
        $contractType: ProjectContractTypeEnum
        $code: String
    ) {
        updateProject(
            projectInput: {
                uniqueId: $uniqueId
                name: $name
                stage: $stage
                status: $status
                code: $code
                contractType: $contractType
            }
        ) {
            data {
                uniqueId
                name
                stage
                status
                methodology
                createdAt
                authoredBy
                subsidiary {
                    id
                    name
                }
            }
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);
